import React, { FC } from 'react'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import {
  Communication,
  CommunicationIconAndNameContainer,
  Container,
  SwitchContainer,
} from '../styles/MeanOfCommunicationSkeleton.styles'

export const MeanOfCommunicationSkeletonView: FC = () => (
  <Container>
    <Communication>
      <CommunicationIconAndNameContainer>
        <Skeleton width="5rem" height="1.25rem" />
      </CommunicationIconAndNameContainer>

      <SwitchContainer>
        <Skeleton width="2.125rem" height="1.25rem" style={{ borderRadius: '3rem' }} />
      </SwitchContainer>
    </Communication>
  </Container>
)
